import React from "react";

function FilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width="24"
      height="24"
    >
      <defs>
        <clipPath id="clippath">
          <rect x="21.5" y="62" width="459.5" height="385.61" fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#clippath)">
        <g>
          <path
            fill="#fff"
            d="M440.08,102.72c11.59,1.89,40.25-5.68,40.58,12.31.35,18.81-29.15,9.82-40.61,12.14-6.67,28.94-35.54,46.99-64.48,40.32-20.15-4.65-35.85-20.44-40.38-40.62l-301.2.16c-18.23-1.89-15.44-23.57,1.89-24.13l299.31.13c7.34-28.99,36.78-46.54,65.77-39.2,19.16,4.85,34.16,19.76,39.12,38.89ZM418.56,115.3c0-16.77-13.6-30.37-30.37-30.37s-30.37,13.6-30.37,30.37,13.6,30.37,30.37,30.37c16.77,0,30.37-13.6,30.37-30.37Z"
          />
          <path
            fill="#fff"
            d="M343.98,381.84l126.31.36c16.64,2.74,12.69,24.06-3.55,23.98l-121.77-.12c-11.93,32.47-44.9,52.04-78.31,35.54-15.51-7.66-22.68-21.69-29.14-36.79l-201.75,1.37c-17.26-.55-20.12-22.19-1.89-24.13l203.2-.21c4.48-9.79,10.26-18.94,17.19-27.18,21.7-20.45,55.87-19.42,76.32,2.28,6.57,6.97,11.16,15.57,13.31,24.9ZM321.76,393.71c0-16.83-13.65-30.48-30.48-30.48s-30.48,13.65-30.48,30.48c0,16.83,13.65,30.48,30.48,30.48s30.48-13.65,30.48-30.48Z"
          />
          <path
            fill="#fff"
            d="M171.94,243.27l303.03,1.16c5.52,2.99,7.57,9.89,4.58,15.41-1.83,3.37-5.23,5.6-9.06,5.91l-297.59-.21c-6.79,29.46-36.17,47.84-65.63,41.05-20.07-4.62-35.84-20.12-40.82-40.1-10.79-4.07-41.88,5.89-44.47-9.26-3.79-22.31,32.62-10.42,44.47-14.61,7-29.09,36.26-47,65.35-40,20.03,4.82,35.59,20.58,40.16,40.67ZM150.06,254.55c0-16.8-13.62-30.41-30.41-30.41s-30.41,13.62-30.41,30.41c0,16.8,13.62,30.41,30.41,30.41s30.41-13.62,30.41-30.41Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default FilterIcon;
